module.exports = __webpack_public_path__ + "static/media/back-icon.f82f6f0c.svg";